/**
 * Skeleton-Primitive — gepulster Platzhalter für Lade-Zustände.
 *
 * Basis für alle Loading-States in der App (statt `<p>Lädt…</p>`).
 * Animation wird automatisch via Tailwind's `animate-pulse` gesteuert und
 * im globalen `prefers-reduced-motion`-Reset entschärft.
 */
import { cn } from "@/lib/utils";

export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      role="status"
      aria-busy="true"
      className={cn("animate-pulse rounded-md bg-muted/70", className)}
      {...props}
    />
  );
}
